<template>
	<v-text-field
		v-model="internalModel"
		:required="required"
		:label="`${label}${required ? ' *' : ''}`"
		:rules="getRules"
		:error="internalError"
		v-on="$listeners"
		v-bind="allProps"
  		autocomplete="null"
	></v-text-field>
</template>

<script>
export default {
	props: {
		label: {
			type: String,
			required: true
		},
		value: {
			type: [String, Number],
			required: false
		},
		rules: {
			type: Array,
			default: () => {
				return [];
			}
		},
		maxlength: {
			type: [Number, String],
			required: false
		},
		required: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			internalError: false,
			requiredMessage: this.$t('requiredMessage'),
			maxlengthMessage: this.$t('maxlengthMessage')
		};
	},
	computed: {
		internalModel: {
			get() {
				return this.value;
			},
			set(newValue) {
				this.$emit('input', newValue);
			}
		},
		allProps() {
			const propsWithoutLabel = { ...this.$props };
			delete propsWithoutLabel.label;
			return { ...this.$attrs, ...propsWithoutLabel };
		},
		getRules() {
			let rules = [...this.rules];
			if (this.required) {
				const func = (value) => !!value || this.requiredMessage;
				const func2 = () => !this.internalError;
				const func3 = () => {
					return this.internalModel === '' || this.internalModel === null ? this.requiredMessage : true;
				};
				rules = [...rules, func, func2, func3];
			}

			if (this.maxlength) {
				const maxlengthREG = new RegExp(`^.{0,${this.maxlength}}$`)
				const func4 = () => (!maxlengthREG.test(this.internalModel) ? this.maxlengthMessage : true);
				rules = [...rules, func4];
			}
			return rules;
		}
	}
};
</script>

<style></style>
